import { Grid, useEventCallback } from '@mui/material';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { ItalianVM } from 'mutation/view-models/civil-union';
import { FormikErrors, FormikTouched } from 'formik';
import { DateTime } from 'luxon';

interface ItalianProps {
  onChange: (key: keyof ItalianVM, value: ItalianVM[keyof ItalianVM]) => void;
  values?: ItalianVM | null;
  errors: FormikErrors<ItalianVM>;
  touched: FormikTouched<ItalianVM>;
  disabled?: boolean;
  fromDate?: DateTime | null;
}

const ItalianComponent = ({
  onChange,
  values,
  errors,
  touched,
  disabled,
  fromDate,
}: ItalianProps): React.ReactElement => {
  const onChangeMunicipalityList = useEventCallback((municipality: MunicipalityAnprVM | null) => {
    onChange('municipality', municipality);
  });

  return (
    <Grid item xs={12} container spacing={1} alignItems="center">
      <Grid item xs={12} md={5}>
        <MunicipalityList
          value={values?.municipality || null}
          onChange={onChangeMunicipalityList}
          label="Comune"
          id="municipality"
          error={touched?.municipality && Boolean(errors?.municipality)}
          disabled={disabled}
          fromDate={fromDate}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Provincia"
          label="Provincia"
          id="provinceOfBirth"
          name="provinceOfBirth"
          fullWidth
          type="text"
          disabled
          variant="outlined"
          value={values?.municipality?.province || ''}
        />
      </Grid>
    </Grid>
  );
};

ItalianComponent.displayName = 'Italian component';

const Italian = memo(ItalianComponent);

export default Italian as typeof ItalianComponent;
